export const ALL_CAMP = "ALL_CAMP";
export const CREATE_CAMP = "CREATE_CAMP";
export const ERROR_CAMP = "ERROR_CAMP";
export const CLEAR_ERROR = "CLEAR_ERROR";
export const SINGLE_CAMP = "SINGLE_CAMP";
export const UPDATE_CAMP = "UPDATE_CAMP";
export const DELETE_CAMP = "DELETE_CAMP";
export const RESET_LOADING = "RESET_LOADING";
